<template>
    <div class="course">
        <div class="banner">
            <div class="banner-content">
                <div class="left">
                <div><span>全面</span>的功能讲解</div>
                <div>我们让产品更加简洁</div>
                <div>专业/高效/价值/产品</div>
                <!-- <div>了解更多</div> -->
                </div>
            </div>
        </div>
        <div class="one one-wrapper">
            <div>乐分享题库系统 · <span style="color:#F88927">个人版</span></div>
            <div>快速入库，兼容各种版本</div>
            <div class="one-content">
                <!-- <ul class="left">
                    <li v-for="(item,index) in arr1" :key="index">
                        <span :class="cur1 === index + 1 ? 'active' : ''" @click="turnVideo(1,index+1,item.url)">{{index + 1}}、{{item.title}}</span>
                    </li>
                </ul> -->
                <div class="left">
                    <div class="tree-title"> <img :src="sph" alt=""> 视频教程，点击学习：</div>
                    <div class="tree-wrap">
                        <el-tree ref="personaltree" :highlight-current="true" node-key="label" :data="personalTree" :props="defaultProps" @node-click="(data)=>handleNodeClick(data,1,'http://www.lefunsoft.com/help/video/exerc_person/客户端视频教程/')">
                            <span class="custom-tree-node" slot-scope="{ node,data }">
                                <span class="custom-wrap"><img :src="data.children ? wjj : sp" alt="">{{ node.label }}</span>
                            </span>
                        </el-tree>
                    </div>
                </div>
                <div class="right">
                    <video ref="video1" :src="src1" controls="controls"></video>
                    <div class="btn">
                        <a class="el-button--warning" :href="path + './soft/LFX_ExercLib__Personal.rar'">点击试用</a>
                        <a href="https://pan.baidu.com/s/1BJr2HyNvJ1j-3zSPoz0oSg" target="_blank">了解更多</a> 提取码：qalk
                    </div>
                </div>
            </div>
        </div>
        <div class="one two">
            <div>乐分享题库系统 · <span style="color:#F88927">网络客户端版</span></div>
            <div>适用于所有行业、全部学科快速建立专业题库！</div>
            <div class="one-content">
                <div class="two-right">
                    <video ref="video2" :src="src2" controls="controls"></video>
                    <div class="btn">
                        <a class="el-button--warning" :href="path + './soft/LFX_ExercLib__Net.rar'">点击试用</a>
                        <div @click="toPage('http://www.lefunsoft.com/help/index.html')">了解更多</div>
                    </div>
                </div>
                <!-- <ul class="left">
                    <li v-for="(item,index) in arr2" :key="index">
                        <span :class="cur2 === index + 1 ? 'active' : ''" @click="turnVideo(2,index+1,item.url)">{{index + 1}}、{{item.title}}</span>
                    </li>
                </ul> -->
                <div class="left">
                    <div class="tree-title" style="background-color:#fff"><img :src="sph" alt=""> 视频教程，点击学习：</div>
                    <div class="tree-wrap">
                        <el-tree class="net-tree" ref="nettree" :highlight-current="true" node-key="label" :data="netTree" :props="defaultProps" @node-click="(data)=>handleNodeClick(data,2,'http://www.lefunsoft.com/help/video/exerc_net/网络版 视频教程/')">
                            <span class="custom-tree-node" slot-scope="{ node,data }">
                                <span class="custom-wrap"><img :src="data.children ? wjj : sp" alt="">{{ node.label }}</span>
                            </span>
                        </el-tree>
                    </div>
                </div>
            </div>
        </div>
        <div class="one one-wrapper">
            <div>乐分享题库系统 · <span style="color:#F88927">网页版</span></div>
            <div>快速入库，兼容各种版本</div>
            <div class="one-content">
                <!-- <ul class="left">
                    <li v-for="(item,index) in arr3" :key="index">
                        <span :class="cur3 === index + 1 ? 'active' : ''" @click="turnVideo(3,index+1,item.url)">{{index + 1}}、{{item.title}}</span>
                    </li>
                </ul> -->
                <div class="left">
                    <div class="tree-title"><img :src="sph" alt=""> 视频教程，点击学习：</div>
                    <div style="font-size: 12px;padding-left: 24px;margin-bottom: 10px;">提示：云题库客户端视频教程请观看相应网络版视频教程</div>
                    <div class="tree-wrap">
                        <el-tree ref="cloudtree" :highlight-current="true" node-key="label" :data="cloudTree" :props="defaultProps" @node-click="(data)=>handleNodeClick(data,3,'http://www.lefunsoft.com/help/video/exerc_web')">
                            <span class="custom-tree-node" slot-scope="{ node,data }">
                                <span class="custom-wrap"><img :src="data.children ? wjj : sp" alt="">{{ node.label }}</span>
                            </span>
                        </el-tree>
                    </div>
                </div>
                <div class="right">
                    <video ref="video3" :src="src3" controls="controls"></video>
                    <div class="btn">
                        <div @click="toPage(tikuUrl)">点击试用</div>
                        <div @click="toPage(tikuUrl + 'useHelp.html')">了解更多</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="one two three">
            <div>乐分享在线考试</div>
            <div>pc端支持浏览器上传、组卷、发布等功能</div>
            <div class="one-content">
                <div class="two-right">
                    <video ref="video4" :src="src4" controls="controls"></video>
                    <!-- <video-player  class="video-player vjs-custom-skin"
                        ref="videoPlayer"
                        :playsinline="true"
                        :options="playerOptions4"
                    ></video-player> -->
                    <div class="btn">
                        <div @click="toPage(examUrl)">点击试用</div>
                        <div @click="toPage(examUrl + 'help')">了解更多</div>
                    </div>
                </div>
                <!-- <ul class="left">
                    <li v-for="(item,index) in arr4" :key="index">
                        <span :class="cur4 === index + 1 ? 'active' : ''" @click="turnVideo(4,index+1,item.url)">{{index + 1}}、{{item.title}}</span>
                    </li>
                </ul> -->
                <div class="left">
                    <div class="tree-title" style="background-color:#fff"><img :src="sph" alt=""> 视频教程，点击学习：</div>
                    <div class="tree-wrap">
                        <el-tree :default-expanded-keys="['上传即考试']" class="exam-tree" ref="examlist" :highlight-current="true" node-key="label" :data="examList" :props="defaultProps" @node-click="(data)=>handleNodeClick(data,4)">
                            <span class="custom-tree-node" slot-scope="{ node,data }">
                                <span class="custom-wrap"><img :src="data.children ? wjj : sp" alt="">{{ node.label }}</span>
                            </span>
                        </el-tree>
                    </div>
                </div>
            </div>
        </div>
        <div class="one one-wrapper">
            <div>PPT批量处理大师</div>
            <div>精致小巧，简单易用，针对性强</div>
            <div class="one-content">
                <!-- <ul class="left">
                    <li v-for="(item,index) in arr5" :key="index">
                        <span :class="cur5 === index + 1 ? 'active' : ''" @click="turnVideo(5,index+1,item.url)">{{item.title}}</span>
                    </li>
                </ul> -->
                <div class="left">
                    <div class="tree-title"><img :src="sph" alt=""> 视频教程，点击学习：</div>
                    <div class="tree-wrap">
                        <el-tree :default-expanded-keys="['插入幻灯片']" ref="ppttree" :highlight-current="true" node-key="label" :data="pptTree" :props="defaultProps" @node-click="(data)=>handleNodeClick(data,5)">
                            <span class="custom-tree-node" slot-scope="{ node,data }">
                                <span class="custom-wrap"><img :src="data.children ? wjj : sp" alt="">{{ node.label }}</span>
                            </span>
                        </el-tree>
                    </div>
                </div>
                <div class="right">
                    <video ref="video5" :src="src5" controls="controls"></video>
                    <!-- <video-player  class="video-player vjs-custom-skin"
                        ref="videoPlayer"
                        :playsinline="true"
                        :options="playerOptions5"
                    ></video-player> -->
                    <div class="btn">
                        <a class="el-button--warning" :href="path + './soft/BatchPPT.rar'">点击试用</a>
                        <a class="el-button--success" :href="path + './help/BatchPPT_Help.rar'">了解更多</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="one two word">
            <div>Word批量处理大师</div>
            <div>一次批量处理最多三万文件，几十个功能自由组合</div>
            <div class="one-content">
                <div class="two-right">
                    <video ref="video6" :src="src6" controls="controls"></video>
                    <!-- <video-player  class="video-player vjs-custom-skin"
                        ref="videoPlayer"
                        :playsinline="true"
                        :options="playerOptions6"
                    ></video-player> -->
                    <div class="btn">
                        <a class="el-button--warning" :href="path + './soft/BatchWord.rar'">点击试用</a>
                        <a class="el-button--success" :href=" path + './help/BatchWord_Help.rar'">了解更多</a>
                    </div>
                </div>
                <!-- <ul class="left">
                    <li v-for="(item,index) in arr6" :key="index">
                        <span :class="cur6 === index + 1 ? 'active' : ''" @click="turnVideo(6,index+1,item.url)">{{item.title}}</span>
                    </li>
                </ul> -->
                <div class="left">
                    <div class="tree-title"><img :src="sph" alt=""> 视频教程，点击学习：</div>
                    <div class="tree-wrap">
                        <el-tree :default-expanded-keys="['超链接设置']" ref="wordtree" :highlight-current="true" node-key="label" :data="wordTree" :props="defaultProps" @node-click="(data)=>handleNodeClick(data,6)">
                            <span class="custom-tree-node" slot-scope="{ node,data }">
                                <span class="custom-wrap"><img :src="data.children ? wjj : sp" alt="">{{ node.label }}</span>
                            </span>
                        </el-tree>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import { videoPlayer } from 'vue-video-player'
import treeList from './js/treeData.js';
import 'video.js/dist/video-js.css'
export default {
    data(){
        return {
            tikuUrl: IPConfig.tikuUrl,
            examUrl: IPConfig.examUrl,
            sp: require('@/assets/icon_shipin.png'),
            sph: require('@/assets/icon_shipinh.png'),
            wjj: require('@/assets/icon_wjj.png'),
            path: process.env.BASE_URL,
            jc: require('@/assets/icon_jc@2x.png'),
            jcIndex: -1,
            value1: 5,
            src1: `http://www.lefunsoft.com/help/video/exerc_person/个人版视频操作教程.mp4`,
            cur1: 1,
            arr1: [
                {
                    title: '试题上传',
                    url: `${process.env.BASE_URL}video/cs/7-02、批量入库（专业）.mp4`
                },
                {
                    title: '题目的快速筛选',
                    url: `${process.env.BASE_URL}video/personal/题目的快速筛选.mp4`
                },
                {
                    title: '智能组卷',
                    url: `${process.env.BASE_URL}video/cs/智能组卷.mp4`
                },
                {
                    title: '从试题篮克隆到新试卷',
                    url: `${process.env.BASE_URL}video/personal/从试题篮克隆到新试卷.mp4`
                },
                {
                    title: '生成Word格式试卷',
                    url: `${process.env.BASE_URL}video/cs/生成试卷（Word）--普通卷.mp4`
                },
                {
                    title: '生成幻灯片',
                    url: `${process.env.BASE_URL}video/personal/导出到幻灯片.mp4`
                },
            ],
            personalTree: treeList.personalList,
            src2: `http://www.lefunsoft.com/help/video/exerc_net/乐分享题库系统  网络版  入门教程.mp4`,
            cur2: 1,
            netTree: treeList.netList,
            src3: `http://www.lefunsoft.com/help/video/exerc_web/网页版操作视频.mp4`,
            cur3: 1,
            cloudTree: treeList.cloudList,
            src4: `${process.env.BASE_URL}video/exam/上传即考试.mp4`,
            cur4: 1,
            examList: treeList.examList,
            src5: `${process.env.BASE_URL}video/ppt/ppt插入幻灯片.mp4`,
            pptTree: treeList.pptList,
            src6: `${process.env.BASE_URL}video/word/超链接设置.mp4`,
            wordTree: treeList.wordList,
            defaultProps: {
                children: 'children',
                label: 'label'
            }
        }
    },
    components: {
        // videoPlayer
    },
    created(){

    },
    mounted(){
        var _self = this;
        var videos = document.getElementsByTagName('video');//获取所有video
        //循环给所有video添加监听事件 当前的video开始播时  调用pauseAll 将当前播放的video的索引传值过去
        for (var i = videos.length - 1; i >= 0; i--) {
            (function(n){
                videos[n].addEventListener('play',function(){
                    _self.pauseAll(n);
                })
            })(i)
        }
        this.$nextTick(() => {
            this.$refs.ppttree.setCurrentKey('插入幻灯片');
            this.$refs.wordtree.setCurrentKey('超链接设置');
            this.$refs.personaltree.setCurrentKey('个人版快速入门');
            this.$refs.nettree.setCurrentKey('网络版快速入门');
            this.$refs.cloudtree.setCurrentKey('网页版快速入门');
            this.$refs.examlist.setCurrentKey('上传即考试');
        })
    },
    methods: {
        handleNodeClick(data,number,baseurl){
            if(data.src){
                if(baseurl){
                    if(data.label === '网络版快速入门'){
                        this[`src${number}`] = 'http://www.lefunsoft.com/help/video/exerc_net/乐分享题库系统  网络版  入门教程.mp4';
                    }else if(data.label === '个人版快速入门'){
                        this[`src${number}`] = 'http://www.lefunsoft.com/help/video/exerc_person/个人版视频操作教程.mp4';
                    }else{
                        this[`src${number}`] = `${baseurl}${data.src}`;
                    }
                }else{
                    this[`src${number}`] = data.src;
                }
                this.$refs[`video${number}`].load();
            }
        },
        pauseAll(index){
            var videos = document.getElementsByTagName('video');//获取所有video
            for (var j = videos.length - 1; j >= 0; j--) {
                if (j!=index){
                    videos[j].pause();
                }
            }
        },
        toPage(url){
            window.open(url);
        },
        turnVideo(number,index,url){
            this[`cur${number}`] = index;
            this[`src${number}`] = url;
            this.$refs[`video${number}`].load();
        }
    }
}
</script>
<style lang="less">
    .course{
        .tree-title{
            font-size: 16px;
            color: #606266;
            margin-bottom: 20px;
            line-height: 46px;
            background-color: #f4f4f4;
            text-align: center;
            display: flex;
            align-items: center;
            padding-left: 20px;
            img{
                margin-right: 10px;
            }
        }
        .tree-wrap{
            width: 400px;
            height: 430px;
            overflow: auto;
            font-family: Microsoft YaHei;
        }
        .el-tree{
            .custom-tree-node{
                .custom-wrap{
                    display: flex;
                    align-items: center;
                    img{
                        vertical-align: top;
                        margin-right: 5px;
                    }
                }
            }
            .el-tree-node>.el-tree-node__children{
                overflow: unset;
            }
            .custom-tree-node{
                font-size: 12px;
            }
            .el-tree-node__content{
                height: 36px;
            }

            .el-tree-node__content:hover{
                .custom-tree-node{
                    display: inline-block;
                    height: 36px;
                    line-height: 36px;
                    background-color: #F5F7FA;
                }
            }
            
            .el-tree-node.is-current{
                >.el-tree-node__content{
                    .custom-tree-node{
                        display: inline-block;
                        height: 36px;
                        line-height: 36px;
                        background-color: #f0f7ff;
                    }
                }
            }
            > .el-tree-node{
                // overflow: auto;
            }
            .el-tree-node.is-expanded > .el-tree-node__children{
                // overflow: auto;
            }
        }
        .el-tree.net-tree,.el-tree.exam-tree{
            background-color: transparent;
            color: #fff;
            .el-tree-node__content:hover{
                color: #53affa;
                .custom-tree-node{
                    display: inline-block;
                    height: 36px;
                    line-height: 36px;
                    background-color: #f0f7ff;
                }
            }
            .el-tree-node.is-current{
                >.el-tree-node__content{
                    .custom-tree-node{
                        color: #53affa;
                    }
                }
            }
            // .el-tree-node.is-focusable{
            //     background-color: transparent;
            //     color: #fff;
            //     .custom-tree-node{
            //         color: #53affa;
            //     }
            // }
        }
        video{
            width: 100%;
            // height: 374px;
        }
        .active{
            box-shadow:0px 0px 14px 0px rgba(176, 176, 176, 0.35);
            color: #53affa;
            background: #fff;
        }
        .banner{
            height: 730px;
            background: #198AF7 url('../assets/img_zxjc@2x.png') no-repeat center center;
            background-size: auto 100%;
            .banner-content{
                width: 1200px;
                position: relative;
                margin: 0 auto;
                .left{
                    position: absolute;
                    top: 230px;
                    left: 0;
                    color: #fff;
                    >div{
                        &:nth-of-type(1){
                            font-size: 36px;
                            span{
                                color: #FFA95E;
                            }
                        }
                        &:nth-of-type(2){
                            font-size: 50px;
                            margin: 8px 0;
                        }
                        &:nth-of-type(3){
                            font-size: 24px;
                        }
                        &:nth-of-type(4){
                            text-align: center;
                            font-size: 20px;
                            width:150px;
                            height:50px;
                            line-height: 50px;
                            border:1px solid rgba(255,255,255,1);
                            border-radius:25px;
                            margin-top: 20px;
                            cursor: pointer;
                            &:hover{
                                background-color: #f88927;
                                border-color: #f88927;
                            }
                        }
                    }
                }
            }
        }
        .one-wrapper{
            padding: 48px 0;
            width: 1200px;
            margin: 0 auto;
            padding-bottom: 88px;
        }
        .one{
            text-align: center;
            >div{
                &:nth-of-type(1){
                    font-size: 36px;
                }
                &:nth-of-type(2){
                    font-size: 20px;
                    color: #808080;
                    margin-top: 10px;
                }
            }
            .one-content{
                display: flex;
                margin-top: 80px;
                .left{
                    padding: 0 60px;
                    font-size: 24px;
                    color: #444444;
                    text-align: left;
                    li{
                        margin-bottom: 10px;
                        span{
                            display: inline-block;
                            padding: 0 20px;
                            cursor: pointer;
                            &:hover{
                                box-shadow:0px 0px 14px 0px rgba(176, 176, 176, 0.35);
                                color: #53affa;
                                background: #fff;
                            }
                        }
                    }
                }
                .right{
                    width: 700px;
                    .btn{
                        margin-top: 30px;
                        >div,>a{
                            text-decoration: none;
                            &:nth-of-type(1){
                                display: inline-block;
                                width:158px;
                                height:50px;
                                line-height:50px;
                                background:rgba(71,180,246,1);
                                box-shadow:0px 2px 13px 0px rgba(1,138,206,0.44);
                                border-radius:25px;
                                color: #fff;
                                margin-right: 50px;
                                cursor: pointer;
                            }
                            &:nth-of-type(2){
                                display: inline-block;
                                color: #fff;
                                width:158px;
                                line-height:50px;
                                background:rgba(248,137,39,1);
                                box-shadow:0px 2px 13px 0px rgba(1,138,206,0.44);
                                border-radius:25px;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
            .video-player{
                .vjs-big-play-button{
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
        .two{
            // height: 750px;
            background: url('../assets/img_bj1.png') no-repeat center center;
            background-size: 100% 100%;
            text-align: center;
            >div{
                &:nth-of-type(1){
                    padding-top: 48px;
                    color: #FFFFFF;
                }
                &:nth-of-type(2){
                    color: #FFFFFF;
                }
            }
            .one-content{
                justify-content: center;
                .left{
                    color: #fff;
                }
            }
            .two-right{
                width: 700px;
                .btn{
                    margin-top: 30px;
                    padding-bottom: 48px;
                    >a{
                        text-decoration: none;
                        display: inline-block;
                        width:158px;
                        height:50px;
                        line-height:50px;
                        background:#fff;
                        box-shadow:0px 2px 13px 0px rgba(1,138,206,0.44);
                        border-radius:25px;
                        color: #484848;
                        margin-right: 50px;
                        cursor: pointer;
                    }
                    >div{
                        display: inline-block;
                        color: #fff;
                        width:158px;
                        line-height:50px;
                        background:rgba(248,137,39,1);
                        box-shadow:0px 2px 13px 0px rgba(1,138,206,0.44);
                        border-radius:25px;
                        cursor: pointer;
                    }
                }
            }
        }
        .three{
            background: url('../assets/img_bj2.png') no-repeat center center;
            background-size: auto 100%;
            .btn{
                >div{
                    text-decoration: none;
                    &:nth-of-type(1){
                        display: inline-block;
                        width:158px;
                        height:50px;
                        line-height:50px;
                        background: #fff;
                        box-shadow:0px 2px 13px 0px rgba(1,138,206,0.44);
                        border-radius:25px;
                        color: #484848;
                        margin-right: 50px;
                        cursor: pointer;
                    }
                    &:nth-of-type(2){
                        display: inline-block;
                        color: #fff;
                        width:158px;
                        line-height:50px;
                        background:rgba(248,137,39,1);
                        box-shadow:0px 2px 13px 0px rgba(1,138,206,0.44);
                        border-radius:25px;
                        cursor: pointer;
                    }
                }
            }
        }
        .word{
            background: #fff;
            >div{
                &:nth-of-type(1){
                    font-size: 36px;
                    color: #000;
                }
                &:nth-of-type(2){
                    font-size: 20px;
                    color: #808080;
                    margin-top: 10px;
                }
            }
            .one-content{
                justify-content: center;
                .left{
                    color: #444444;
                    // padding: 0;
                    &:nth-of-type(1){
                        margin-left: 60px;
                    }
                }
                .btn{
                    >a{
                        text-decoration: none;
                        &:nth-of-type(1){
                            display: inline-block;
                            width:158px;
                            height:50px;
                            line-height:50px;
                            background:rgba(71,180,246,1);
                            box-shadow:0px 2px 13px 0px rgba(1,138,206,0.44);
                            border-radius:25px;
                            color: #fff;
                            margin-right: 50px;
                            cursor: pointer;
                        }
                        &:nth-of-type(2){
                            display: inline-block;
                            color: #fff;
                            width:158px;
                            line-height:50px;
                            background:rgba(248,137,39,1);
                            box-shadow:0px 2px 13px 0px rgba(1,138,206,0.44);
                            border-radius:25px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
</style>